// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLumeraParking_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14 17C14 20.866 10.866 24 7 24C3.13401 24 0 20.866 0 17C0 13.134 3.13401 10 7 10C10.866 10 14 13.134 14 17Z" fill="#738FBA"/>
  <path d="M7.32 12.9297C8.424 12.9297 9.228 13.1697 9.732 13.6497C10.244 14.1217 10.5 14.7737 10.5 15.6057C10.5 16.1097 10.396 16.5777 10.188 17.0097C9.98 17.4417 9.632 17.7897 9.144 18.0537C8.664 18.3177 8.008 18.4497 7.176 18.4497H6.396V21.4977H4.584V12.9297H7.32ZM7.224 14.4177H6.396V16.9617H6.996C7.508 16.9617 7.912 16.8617 8.208 16.6617C8.512 16.4537 8.664 16.1217 8.664 15.6657C8.664 14.8337 8.184 14.4177 7.224 14.4177Z" class="svg-fg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M19 0H17C15.2846 0 12.4092 0.671588 9.95151 2.9108C8.59381 4.14782 7.39377 5.83533 6.58283 8.09153C6.7211 8.08522 6.86018 8.08203 7 8.08203C7.5703 8.08203 8.12821 8.13508 8.66907 8.2365C9.36535 6.53761 10.3051 5.29427 11.2985 4.3892C13.3408 2.52841 15.7154 2 17 2V4H15V8.8309L12.0358 9.62166C12.7009 10.0715 13.3026 10.6079 13.8247 11.2147L15 10.9014V12H21V10.901L23.4472 11.5602L24 9.62839L21 8.83043V4H19V0ZM17 6V10H19V6H17Z" class="svg-bg"/>
  <path d="M4.35669 8.47646C3.89975 8.61664 3.45829 8.79222 3.03551 9H0V1H9.10305C8.93544 1.13834 8.76916 1.28242 8.60453 1.43241C8.08685 1.90408 7.59471 2.42575 7.13491 3H2L2 7H4.85599C4.67282 7.47145 4.50591 7.96342 4.35669 8.47646Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLumeraParking is a generated icon component.
 */
let IconMedLumeraParking = IconMedLumeraParking_1 = class IconMedLumeraParking extends IconBaseElement {
    render() {
        return html `${IconMedLumeraParking_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLumeraParking.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedLumeraParking = IconMedLumeraParking_1 = __decorate([
    customElement('zui-icon-med-lumera-parking')
], IconMedLumeraParking);
export { IconMedLumeraParking };
